import Vue from "vue";
export const NestedEditorsEventBus = new Vue();
